import React from "react";
import { useSettings } from "@/context/SettingsContext";
import { ShieldCheck } from "lucide-react";

export function BrandLogo({ light = false, className = "" }) {
  const settings = useSettings();
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      {settings.logo_url ? (
        <img src={settings.logo_url} alt="Care Placement Pro" className="h-9 w-auto object-contain" />
      ) : (
        <div className={`flex h-9 w-9 items-center justify-center rounded-lg ${light ? "bg-white" : "bg-navy"}`}>
          <ShieldCheck className={`h-5 w-5 ${light ? "text-navy" : "text-white"}`} strokeWidth={2.2} />
        </div>
      )}
      <div className="leading-tight">
        <div className={`font-heading text-[15px] font-bold tracking-tight ${light ? "text-white" : "text-navy"}`}>
          Care Placement Pro
        </div>
        <div className={`text-[9px] font-semibold uppercase tracking-[0.14em] ${light ? "text-slate-300" : "text-slate-500"}`}>
          Powered by Eagle Healthcare Services
        </div>
      </div>
    </div>
  );
}

export function PoweredByEagle({ className = "" }) {
  return (
    <p className={`text-xs font-semibold uppercase tracking-[0.14em] text-slate-400 ${className}`}>
      Powered by Eagle Healthcare Services, Inc.
    </p>
  );
}
